import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
// import apihostname from "services/apihostname";

import { Form, Col, Row, FormControl } from "react-bootstrap";

import UserService from "../../services/user.service";

import { toast } from "react-toastify";

function Modaledituser(props) {
  const initialValue = {
    academyId: "",
    factoryId: "",
    member_id: "",
    member_type: "",
    ocsbId: "",
    regID: "",
    registerEmail: "",
    registerFname: "",
    registerLname: "",
    registerPhone: null,
    registerProfileImg: null,
    registerUsername: "",
    ca_file: null,
  };
  const [form, setForm] = useState(initialValue);
  const [errors, setErrors] = useState({});
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [ocsb, setOcsb] = useState([]);
  const [academy, setAcademy] = useState([]);
  const [factory, setFactory] = useState([]);
  const [region, setRegion] = useState([]);
  const [listRoles, setListRoles] = useState([]);

  const handleClose = () => {
    props.hidden(false);
    // setForm(initialValue);
    // setImage({ preview: "", raw: "" });
  };

  //   console.log("editform");
  //   const [acceptedTerms, setAcceptedTerms] = useState(false);

  // const getOption = () => {
  //   UserService.getOcsb()
  //     .then((response) => {
  //       setOcsb(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.error("error fetching getOcsb: ", error);
  //     });
  //   UserService.getAcademylist()
  //     .then((response) => {
  //       setAcademy(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.error("error fetching getAcademy: ", error);
  //     });
  //   UserService.getFactorylist()
  //     .then((response) => {
  //       setFactory(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.error("error fetching getFactory: ", error);
  //     });
  // };
  // console.log(getOption());
  // useEffect(() => {
  //   getOption();
  // }, []);
  useEffect(() => {
    UserService.listRoles()
      .then((response) => {
        setListRoles(response.data.data);
      })
      .catch((error) => console.log(error));
    UserService.getOcsb()
      .then((response) => {
        setOcsb(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getOcsb: ", error);
      });
    UserService.getAcademylist()
      .then((response) => {
        setAcademy(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getAcademy: ", error);
      });
    UserService.getFactorylist()
      .then((response) => {
        setFactory(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getFactory: ", error);
      });
    UserService.getRegionlist()
      .then((response) => {
        setRegion(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getFactory: ", error);
      });
  }, []);

  // setImage(props.image);
  // setForm(props.formdata);

  useEffect(() => {
    setForm(props.formdata);
  }, [props.formdata.member_id]);
  useEffect(() => {
    setImage(props.image);
  }, [props.image.preview]);
  // const setEdit = (edit) => {
  //   console.log("click edit");
  //   let newform = {};
  //   for (const prop in edit) {
  //     console.log(`obj.${prop} = ${edit[prop]}`);
  //     newform[prop] = edit[prop];
  //   }
  //   setForm(newform);
  // };

  // setEdit();

  // const setEditForm = (userid) => {
  //   UserService.getUserprofile(userid)
  //     .then((response) => {
  //       // setForm(initialValue);
  //       setForm(response.data.user);
  //       setImage({
  //         preview: apihostname + response.data.user.registerProfileImg,
  //         raw: "",
  //       });
  //     })
  //     .catch((error) => {
  //       toast.error(error);
  //     });

  //   setErrors({});
  //   // setForm({ member_type: "0" });
  // };
  const setField = (field, value) => {
    if (field.files) {
      if (field.name === "ca_file") {
        console.log(field.name);
        console.log(field.files[0]);
        setForm({
          ...form,
          [field.name]: field.files[0],
        });
      } else {
        setImage({
          preview: URL.createObjectURL(field.files[0]),
        });
        setForm({
          ...form,
          [field.name]: field.files[0],
        });
      }
    } else {
      setForm({
        ...form,
        [field.name]: value,
      });
      if (errors[field.name])
        setErrors({
          ...errors,
          [field.name]: null,
        });
    }
  };
  const findFormErrors = () => {
    const {
      member_type,
      // registerEmail,
      // registerUsername,
      user_reg,
      academy,
      titlename,
      position,
      registerFname,
      registerLname,
      // registerPassword,
      // conPassword,
    } = form;
    const newErrors = {};

    // member_type errors
    if (!registerFname || registerFname === "")
      newErrors.registerFname = "กรุณากรอกชื่อ";

    // member_type errors
    if (!registerLname || registerLname === "")
      newErrors.registerLname = "กรุณากรอกนามสกุล";
    // member_type errors
    if (!member_type || member_type === "0")
      newErrors.member_type = "กรุณาเลือกข้อมูล";

    // titlename errors
    if (!titlename || titlename === "")
      newErrors.titlename = "กรุณากรอกคำนำหน้าชื่อ";

    // position errors
    if (!position || position === "") newErrors.position = "กรุณากรอกตำแหน่ง";

    // check select user_reg;
    if (
      (member_type === "2" || member_type === "3") &&
      (!user_reg || user_reg === "0")
    )
      newErrors.user_reg = "กรุณาเลือกข้อมูล";

    // Check select assoc
    if (member_type === "4" && (!academy || academy === "0"))
      newErrors.academy = "กรุณาเลือกข้อมูล";

    // registerEmail errors
    // if (!registerEmail || registerEmail === "")
    //   newErrors.registerEmail = "กรุณากรอก Email";

    // registerUsername errors
    // if (!registerUsername || registerUsername === "")
    //   newErrors.registerUsername = "กรุณากรอก Username";
    // else if (registerUsername.length < 4)
    //   newErrors.registerUsername = "Username ต้องมากกว่า 5 ตัว";

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    for (const key in form) {
      data.append(key, form[key]);
    }

    // get our new errors
    const newErrors = findFormErrors();
    // Conditional logic:
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      // alert(JSON.stringify(form));
      console.log(newErrors);
      setErrors(newErrors);
    } else {
      // No errors! Put any logic here for the form submission!
      // alert("Thank you for your feedback!");
      console.log(form);
      UserService.updateUserprofile(props.userid, data)
        .then((response) => {
          if (response.data.success) {
            var newArray = props.data.map(function (el) {
              if (el.user_id != props.userid) {
                return el;
              } else {
                var check = response.data.user;
                // check.assoc_approve = approv;
                // if (id.row.assoc_approve == 1) {
                //   check.assoc_approve = approv;
                // } else {
                //   check.assoc_approve = 1;
                // }
                return check;
              } // Changed this so a home would match
            });

            props.setdata([...newArray]);
            toast.success("บันทึกข้อมูลเรียบร้อย");
          }
          // window.location.reload(true);
          // const rows = props.data.push(response.data.user);
          // props.editData(rows);
          // initialForm();
        })
        .catch((error) => {
          // console.error("error fetching data: ", error);
          toast.error(error);
        })
        .finally(() => {
          props.hidden(false);
        });
    }
  };
  //   const handleUpload = async (e) => {
  //     e.preventDefault();
  //     const formData = new FormData();
  //     formData.append("image", image.raw);
  //   };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>แก้ไข</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="uploadpic">
            <label htmlFor="upload-button">
              {image.preview && image.preview != "" ? (
                <img
                  src={image.preview + "?" + new Date().getTime()}
                  alt="dummy"
                  width="150"
                  height="150"
                />
              ) : (
                <>
                  <span className="fa-stack fa-2x mt-3 mb-2">
                    <i className="fas fa-circle fa-stack-2x" />
                    <i className="fas fa-store fa-stack-1x fa-inverse" />
                  </span>
                  <h5 className="text-center">Upload your photo</h5>
                </>
              )}
            </label>
            <input
              type="file"
              id="upload-button"
              name="registerProfileImg"
              style={{ display: "none" }}
              onChange={(e) => setField(e.target, e.target.value)}
            />
            <br />
            {/* <Button variant="primary" type="button" onClick={handleUpload}>
            อัพโหลด
          </Button> */}
          </div>
          <Form>
            <Row>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>ประเภทผู้ใช้งาน</Form.Label>
                  <Form.Select
                    name="member_type"
                    value={form.member_type}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.member_type}
                  >
                    <option value="">เลือกประเภทผู้ใช้งาน</option>
                    {listRoles.map((item, key) => {
                      return (
                        <option key={key} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                    {/* <option value="1">ผู้ดูแลระบบ</option>
                    <option value="2">เจ้าหน้าที่จดทะเบียน</option>
                    <option value="3">นายทะเบียน</option>
                    <option value="4">เจ้าหน้าที่สมาคม</option>
                    <option value="5">เจ้าหน้าที่ สอน.</option>
                    <option value="6">เจ้าหน้าที่ สอน.2</option>
                    <option value="7">เจ้าหน้าที่ โรงงาน</option> */}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.member_type}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>เขต</Form.Label>
                  <Form.Select
                    name="user_reg"
                    value={form.user_reg}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.user_reg}
                  >
                    <option value="">เลือกเขต</option>
                    {region.map((o) => (
                      <option key={o.region_id} value={o.region_code}>
                        {o.region_name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.user_reg}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>สอน.</Form.Label>
                  <Form.Select
                    name="ocsbId"
                    value={form.ocsbId}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.ocsbId}
                  >
                    <option value="">เลือกหน่วยงาน สอน.</option>
                    {ocsb.map((o) => (
                      <option key={o.ocsbId} value={o.ocsbId}>
                        {o.ocsbName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.ocsbId}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>สถาบัน</Form.Label>
                  <Form.Select
                    name="academyId"
                    value={form.academyId}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.academyId}
                  >
                    <option value="">เลือกสถาบัน</option>
                    {academy.map((o) => (
                      <option key={o.academyId} value={o.academyId}>
                        {o.academyName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.academyId}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>โรงงาน</Form.Label>
                  <Form.Select
                    name="factoryId"
                    value={form.factoryId}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.factoryId}
                  >
                    <option value="">เลือกโรงงาน</option>
                    {factory.map((o) => (
                      <option key={o.factoryId} value={o.factoryId}>
                        {o.factoryName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.factoryId}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="2">
                <Form.Group className="mb-2">
                  <Form.Label>คำนำหน้าชื่อ</Form.Label>
                  <FormControl
                    placeholder="คำนำหน้าชื่อ"
                    name="titlename"
                    value={form.titlename || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.titlename}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.titlename}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="5">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อ</Form.Label>
                  <FormControl
                    placeholder="ชื่อ"
                    name="registerFname"
                    value={form.registerFname || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.registerFname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registerFname}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="5">
                <Form.Group className="mb-2">
                  <Form.Label>นามสกุล</Form.Label>
                  <FormControl
                    placeholder="นามสกุล"
                    name="registerLname"
                    value={form.registerLname || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.registerLname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.registerLname}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group className="mb-2">
                  <Form.Label>ตำแหน่ง</Form.Label>
                  <FormControl
                    placeholder="ตำแหน่ง"
                    name="position"
                    value={form.position || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.position}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.position}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col md="10">
                <Form.Group className="mb-3">
                  <Form.Label>
                    CA ไฟล์ :{" "}
                    {form.ca_file_name !== "" ? form.ca_file_name : "-"}{" "}
                  </Form.Label>
                  <Form.Control
                    type="file"
                    label="เลือกไฟล์"
                    name="ca_file"
                    onChange={(e) => setField(e.target, e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button className="btn btn-primary" onClick={handleSubmit}>
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Modaledituser;

Modaledituser.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.array,
  setdata: PropTypes.func,
  userid: PropTypes.number,
  formdata: PropTypes.object,
  image: PropTypes.object,
  setSelectData: PropTypes.func,
  setSelectImage: PropTypes.func,
};
